import { Clock, Check, CalendarHeart } from "lucide-react";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import services from "@/data/services.json";
import { formatBRL } from "@/lib/format";

export default function Services({ onSchedule }) {
    return (
        <section id="servicos" data-testid="services-section" className="relative py-20 lg:py-28">
            <div className="container-x">
                <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
                    <SectionHeading
                        eyebrow="Banho, tosa & care"
                        title={
                            <>
                                Serviços que transformam <em className="text-coral">o dia do seu pet</em>
                            </>
                        }
                        description="Agendamento demonstrativo — escolha um serviço e veja como seria simples marcar um mimo."
                    />
                    <Reveal delay={0.2}>
                        <span className="inline-flex items-center gap-2 rounded-full border border-coral/30 bg-coral/10 px-4 py-2 text-[11px] font-extrabold uppercase tracking-[0.18em] text-coral-dark">
                            <CalendarHeart className="h-4 w-4" />
                            Agendamento demo
                        </span>
                    </Reveal>
                </div>

                <div className="mt-12 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
                    {services.map((service, i) => (
                        <Reveal key={service.id} delay={0.08 * i} className="h-full">
                            <article
                                data-testid={`service-card-${i + 1}`}
                                className="group flex h-full flex-col overflow-hidden rounded-[1.75rem] border border-sand bg-cream-card shadow-[0_2px_12px_rgba(23,61,53,0.05)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_48px_rgba(23,61,53,0.16)]"
                            >
                                <div className="relative aspect-[16/11] overflow-hidden">
                                    <img
                                        src={service.image}
                                        alt={service.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                    <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-cream/90 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-forest backdrop-blur">
                                        <Clock className="h-3 w-3" />
                                        {service.duration}
                                    </span>
                                </div>
                                <div className="flex flex-1 flex-col p-5">
                                    <h3 className="font-serif text-lg font-bold leading-snug text-forest">
                                        {service.title}
                                    </h3>
                                    <p className="mt-2 text-[13px] leading-relaxed text-graphite-muted">
                                        {service.description}
                                    </p>
                                    <ul className="mt-4 flex flex-col gap-1.5">
                                        {service.includes.map((inc) => (
                                            <li
                                                key={inc}
                                                className="flex items-start gap-2 text-xs text-forest/80"
                                            >
                                                <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-coral" />
                                                {inc}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="mt-auto flex items-center justify-between gap-3 pt-5">
                                        <div className="flex flex-col">
                                            <span className="text-sm font-extrabold text-forest">
                                                a partir de {formatBRL(service.priceFrom)}
                                            </span>
                                            <span className="text-[9px] font-extrabold uppercase tracking-[0.14em] text-coral-dark">
                                                Preço fictício
                                            </span>
                                        </div>
                                        <button
                                            type="button"
                                            data-testid={`service-schedule-button-${i + 1}`}
                                            onClick={() => onSchedule(service.id)}
                                            className="rounded-full bg-forest px-5 py-2.5 text-xs font-bold text-cream transition-all duration-300 hover:bg-coral hover:text-forest"
                                        >
                                            Agendar (demo)
                                        </button>
                                    </div>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
